import type { SVGProps } from 'react';

const AutomaticPayments = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="none"
    width="1em"
    height="1em"
    {...props}
  >
    <path
      d="M24.0837 15.9791V10.7083C24.0837 9.64975 23.2255 8.79163 22.167 8.79163H6.83366C5.77511 8.79163 4.91699 9.64975 4.91699 10.7083V20.2916C4.91699 21.3502 5.77511 22.2083 6.83366 22.2083H16.417M4.91699 13.5833H24.0837"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M28 18.5L22.5 24L20 21.5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default AutomaticPayments;
